// Task #3653 — Contratto dati unico BE↔FE: schemi Zod di RISPOSTA per la
// dashboard master (route backend `analytics.ts` cross-tenant e
// `superadmin-dashboard.routes.ts`). Tipi derivati con `z.infer`, SoT unica
// condivisa. Vedere docs/zod-boundary.md § Risposte.
import { z } from 'zod';

/**
 * GET /master/analytics/cross-tenant/summary — riga aggregata pg: i COUNT/SUM/AVG
 * sono serializzati come STRINGA dal driver (memoria pg-numeric-string) e AVG/SUM
 * possono essere null senza CDR nel periodo.
 */
export const crossTenantSummarySchema = z.object({
  total_tenants: z.string(),
  active_tenants: z.string(),
  total_users: z.string(),
  total_extensions: z.string(),
  total_calls: z.string(),
  active_calls: z.string(),
  avg_call_duration: z.string().nullable(),
  total_call_duration: z.string().nullable(),
});
export type CrossTenantSummary = z.infer<typeof crossTenantSummarySchema>;

/**
 * GET /master/analytics/cross-tenant/calls-trend — bucket temporale.
 * `avg_duration` è numeric pg → stringa; i COUNT sono bigint → stringa.
 */
export const crossTenantCallTrendPointSchema = z.object({
  time_bucket: z.string(),
  total_calls: z.string(),
  inbound_calls: z.string(),
  outbound_calls: z.string(),
  internal_calls: z.string(),
  avg_duration: z.string().nullable(),
  total_duration: z.string().nullable(),
});
export type CrossTenantCallTrendPoint = z.infer<typeof crossTenantCallTrendPointSchema>;

/**
 * GET /master/dashboard/tenants — la route normalizza già i conteggi con
 * parseInt lato backend: qui sono NUMBER, non stringhe.
 */
export const masterDashboardTenantItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  status: z.string(),
  domain: z.string().nullable(),
  sip_domain: z.string().nullable(),
  product: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  user_count: z.number(),
  extension_count: z.number(),
  store_count: z.number(),
  calls_24h: z.number(),
  calls_7d: z.number(),
  contacts_count: z.number(),
});
export type MasterDashboardTenantItem = z.infer<typeof masterDashboardTenantItemSchema>;

export const masterDashboardTenantsResponseSchema = z.object({
  tenants: z.array(masterDashboardTenantItemSchema),
});
export type MasterDashboardTenantsResponse = z.infer<typeof masterDashboardTenantsResponseSchema>;

/**
 * `POST /master/dashboard/impersonate-tenant/:tenantId` → `data`: token
 * one-shot di impersonificazione + utente impersonato (admin del tenant).
 */
export const masterImpersonateTenantResultSchema = z.object({
  token: z.string(),
  impersonated_user: z.object({
    id: z.string(),
    email: z.string(),
    role: z.string(),
    tenant_slug: z.string(),
  }),
  expires_in: z.string(),
});
export type MasterImpersonateTenantResult = z.infer<typeof masterImpersonateTenantResultSchema>;
